import styled, { css, keyframes } from "styled-components";

const fadeIn = keyframes`
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
`;

export const ModalOverlay = styled.div`
	position: fixed;
	inset: 0;
	z-index: 10001;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 20px;
	padding: 20px;
	background: var(
		--modal-overlay-bg,
		linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%),
			linear-gradient(0deg, rgba(255, 128, 47, 0.2) 0%, rgba(255, 128, 47, 0.2) 100%),
			linear-gradient(0deg, rgba(26, 27, 43, 0.6) 0%, rgba(26, 27, 43, 0.6) 100%),
			radial-gradient(50% 50% at 50% 50%, rgba(80, 46, 128, 0.07) 0%, rgba(0, 0, 0, 0.9) 100%)
	);
	background-blend-mode: normal, color, normal, normal;
	backdrop-filter: blur(12.5px);
	animation: ${fadeIn} 0.2s ease-in;
	overflow-y: auto;

	.close-icon {
		cursor: pointer;
		flex-shrink: 0;
	}

	${() =>
		window.HAS_LESS_BORDER_RADIUS &&
		css`
			background: linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%),
				linear-gradient(0deg, rgba(47, 255, 179, 0) 0%, rgba(47, 255, 179, 0) 100%),
				linear-gradient(0deg, rgba(32, 37, 34, 0.6) 0%, rgba(32, 37, 34, 0.6) 100%),
				radial-gradient(
					50% 50% at 50% 50%,
					rgba(22, 41, 63, 0.6) 0%,
					rgba(0, 0, 0, 0.6) 100%
				);
			background-blend-mode: normal, color, normal, normal;
		`}
`;

export const ModalWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: min(100%, 320px);
	border-radius: 25px;
	background: var(--modal-bg, linear-gradient(180deg, #191726 0%, #050512 100%));
	padding: 20px;
	position: relative;
	overflow: visible;
	box-sizing: border-box;
	gap: 16px;

	@media (min-width: 1024px) {
		width: 460px;
		padding: 30px;
	}

	${() =>
		window.HAS_LESS_BORDER_RADIUS &&
		css`
			box-shadow: 0 0 34px rgba(51, 255, 109, 0.1);
			background: linear-gradient(
				180deg,
				rgba(2, 19, 21, 0.8) 9.72%,
				rgba(12, 49, 55, 0.8) 50.54%,
				rgba(3, 11, 17, 0.8) 100%
			);
		`}
`;

export const ModalTitle = styled.div`
	color: var(--main-color);
	text-align: center;
	text-transform: uppercase;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.75px;

	${() =>
		window.HAS_LESS_BORDER_RADIUS &&
		css`
			color: var(--modal-text-color);
		`}
`;

export const FormWrapper = styled.div`
	width: 100%;

	.auth-form-item {
		margin-bottom: 0;
	}

	.select {
		position: relative;

		.ant-select-selection-search-input,
		.ant-select-selection-placeholder,
		.ant-select-selection-item {
			padding-left: 12px !important;
		}

		.ant-select-arrow {
			margin-right: 7px;
		}
	}
`;

export const ActionsWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	width: 100%;
	margin-top: 4px;

	${(props) =>
		props.$disabled &&
		css`
			opacity: 0.5;
			pointer-events: none;
		`}

	.complete-btn.ant-btn-primary {
		display: inline-flex;
		height: 44px;
		min-width: 110px;
		max-width: 160px;
		flex: 1;
		padding: 0 20px;
		justify-content: center;
		align-items: center;
		border-radius: 25px;
		background: var(--sign-in-btn-bg, var(--main-gradient, var(--main-explosive-gradient))) !important;
		border: none !important;
		color: var(--button-color, #fff) !important;
		text-align: center;
		font-size: 12px;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;
		text-transform: uppercase;
		box-shadow: none !important;
		text-shadow: none;

		&:hover,
		&:focus {
			color: var(--button-color, #fff) !important;
			background: var(--sign-in-btn-bg, var(--main-gradient, var(--main-explosive-gradient))) !important;
			opacity: 0.92;
		}

		&[disabled],
		&[disabled]:hover {
			color: var(--button-color, #fff) !important;
			background: var(--sign-in-btn-bg, var(--main-gradient, var(--main-explosive-gradient))) !important;
			opacity: 0.5;
		}
	}

	.cancel-btn.ant-btn-primary {
		display: inline-flex;
		height: 44px;
		min-width: 110px;
		max-width: 160px;
		flex: 1;
		padding: 0 20px;
		justify-content: center;
		align-items: center;
		border-radius: 25px;
		background: var(--sign-up-btn-bg, var(--main-gray)) !important;
		border: 1px solid var(--sign-up-btn-border, transparent) !important;
		color: var(--sign-up-btn-text, var(--button-color, #fff)) !important;
		text-align: center;
		font-size: 12px;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;
		text-transform: uppercase;
		box-shadow: none !important;
		text-shadow: none;

		&:hover,
		&:focus {
			color: var(--sign-up-btn-text, var(--button-color, #fff)) !important;
			background: var(--sign-up-btn-bg, var(--main-gray)) !important;
			border-color: var(--sign-up-btn-border, transparent) !important;
			opacity: 0.92;
		}
	}
`;
